module.exports = __webpack_public_path__ + "static/media/search_icon_primary.01b22a9a.svg";